import createWebStorage from 'redux-persist/lib/storage/createWebStorage'

/**
 * Why we need to implement below interface ?
 * @see https://github.com/vercel/next.js/discussions/15687#discussioncomment-45319
 */
const createNoopStorage = () => {
  return {
    getItem(_key: string) {
      return Promise.resolve(null)
    },
    setItem(_key: string, value: string) {
      return Promise.resolve(value)
    },
    removeItem(_key: string) {
      return Promise.resolve()
    },
  }
}

const storage = typeof window !== 'undefined' ? createWebStorage('local') : createNoopStorage()

export default storage
